import { getPhaseAnchorState } from './phaseAnchor';
import './PhaseAnchor.css';
import CoreboundIcon from './CoreboundIcon';

const PhaseAnchorControl = ({ game }) => {
  const anchor = getPhaseAnchorState(game);
  if (!anchor.owned) return null;
  return (
    <div className="coreboundPhaseAnchorSetup">
      <div>
        <strong>
          <CoreboundIcon name="phaseAnchor" /> Phase Anchor{' '}
          <small>RARE · ACTIVE</small>
        </strong>
        <span role="status">
          {anchor.used
            ? 'Used this floor · Recharges next floor'
            : 'Ready · Tap Activate Anchor while your die moves · One use per floor'}
        </span>
      </div>
    </div>
  );
};

export default PhaseAnchorControl;
